import { registrationSteps } from '@/mocks/radioRegistrationSimple';

export default function OnboardingRadiosSection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden bg-background-50">
      {/* Subtle ambient glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-emerald-400/3 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-teal-400/3 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-semibold mb-5">
            <i className="ri-rocket-line text-xs"></i>
            Empezá Hoy
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 tracking-tight leading-[1.1]">
            Creá tu radio en{' '}
            <span className="text-emerald-600">4 pasos</span>
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Sin tecnicismos. Sin formularios eternos. Solo lo esencial para que salgas al aire.
          </p>
        </div>

        {/* Steps — horizontal on desktop, stack on mobile */}
        <div className="relative">
          {/* Connecting line — desktop only */}
          <div className="hidden lg:block absolute top-16 left-[12.5%] right-[12.5%] h-[1px] bg-gradient-to-r from-emerald-200 via-teal-200 to-emerald-200"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-3">
            {registrationSteps.map((step) => (
              <div
                key={step.id}
                className="group relative flex flex-col items-center text-center p-7 md:p-6 rounded-2xl bg-background-50 border border-background-200/50 hover:border-emerald-200/60 transition-all duration-300 hover:-translate-y-1"
              >
                {/* Step number — large and subtle */}
                <div className="absolute top-4 right-5 text-5xl md:text-6xl font-extrabold text-background-200/60 group-hover:text-emerald-100/70 transition-colors duration-300 pointer-events-none select-none tabular-nums">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="relative z-10 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600 group-hover:bg-emerald-500 group-hover:text-white transition-all duration-300 mb-5">
                  <i className={`${step.icon} text-xl md:text-2xl`}></i>
                </div>

                {/* Title */}
                <h3 className="relative z-10 text-base md:text-lg font-bold text-foreground-950 mb-2.5 whitespace-nowrap">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="relative z-10 text-xs md:text-sm text-foreground-500 leading-relaxed max-w-[240px]">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 md:mt-14 text-center">
          <a
            href="/register-radio"
            className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-emerald-500 text-white rounded-full text-sm font-bold hover:bg-emerald-600 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-emerald-500/15"
          >
            <i className="ri-rocket-line"></i>
            Registrar mi radio ahora
            <i className="ri-arrow-right-line"></i>
          </a>

          <p className="mt-4 text-xs text-foreground-400">
            Frecuencia RFW automática incluida. Sin costo adicional.
          </p>
        </div>
      </div>
    </section>
  );
}